import React from 'react';
import Button from './Button.js';

const SectionButton = ({ link }) => {
    return (
        <div className="section-container black">
            <div className='text-column-line'>
                <h4 className='white large'> Essa promoção pode acabar em breve!</h4>
            </div>
            <div className="image-column">
                <Button href={link} />
            </div>
        </div>
    );
};

export default SectionButton;
